import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpParams,
	HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { ECPStore } from 'src/app/state-management/stores/ecp.store';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
	private apiBaseUrl = environment.apiBaseUrl;
	private apiVersion = environment.apiVersion;

	private readonly ecpStore = inject(ECPStore);

	constructor(private readonly oAuthService: OAuthService) {}

	public intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler,
	): Observable<HttpEvent<unknown>> {
		if (request.url.startsWith(this.apiBaseUrl)) {
			const token = this.oAuthService.getIdToken();

			let params = request.params ? request.params : new HttpParams();

			if (request.url.endsWith('/public/api/oe/ECPs/Stores') === false) {
				const selectedSoldTo = this.ecpStore.selectedSoldToStore();

				params = params.set('ZeissCustomerNumber', selectedSoldTo?.customerNumber || '');
			}

			request = request.clone({
				params: params,
				setHeaders: {
					Authorization: `Bearer ${token}`,
					'X-Version': this.apiVersion,
				},
			});
		}

		return next.handle(request);
	}
}
